//assets/video-controls-slide.js

import { Component } from '@theme/component';

/**
 * Play/pause and mute/unmute controls for slide background videos.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} [playButton] - Play/pause toggle button
 * @property {HTMLElement} [muteButton] - Mute/unmute toggle button
 *
 * @extends {Component<Refs>}
 */

class VideoControlsComponent extends Component {
  connectedCallback(){
    super.connectedCallback();
    const video = this.video;
    const { muteButton, playButton } = this.refs;

    if (video && muteButton instanceof HTMLElement) {
      muteButton.classList.toggle('is-muted', video.muted);
      muteButton.setAttribute('aria-pressed', String(video.muted));
    }

    if (video && playButton instanceof HTMLElement) {
      const syncPlay = () => {
        const isPlaying = !video.paused;
        playButton.classList.toggle('is-playing', isPlaying);
        playButton.setAttribute('aria-pressed', String(isPlaying));
      };
      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
      syncPlay();
    }
  }

  get video() {
    const video =
      this.closest('.slide__image-container')?.querySelector('video') ??
      this.closest('deferred-media')?.querySelector('video');
    const result = video instanceof HTMLVideoElement ? video : null;
    if (!result) console.warn('[video-controls] video not found');
    return result;
  }

  togglePlay() {
    const video = this.video;

    if (!video) return;

    const willPlay = video.paused;
    willPlay ? video.play() : video.pause();

    const { playButton } = this.refs;
    if (playButton instanceof HTMLElement) {
      playButton.classList.toggle('is-playing', willPlay);
      playButton.setAttribute('aria-pressed', String(willPlay));
    } else {
      console.warn('[slide-video-controls] playButton ref not found');
    }
  }

  toggleMute() {
    const video = this.video;
    if (!video) return;

    video.muted = !video.muted;

    const { muteButton } = this.refs;
    if (muteButton instanceof HTMLElement) {
      muteButton.classList.toggle('is-muted', video.muted);
      muteButton.setAttribute('aria-pressed', String(video.muted));
    } else {
      console.warn('[slide-video-controls] muteButton ref not found');
    }
  }
}

if (!customElements.get('video-controls-component')) {
  customElements.define('video-controls-component', VideoControlsComponent);
}